module.exports = __webpack_public_path__ + "static/media/logout.e57b22fb.svg";